'use client';

import { Typography } from '@capsule/consumer-design-system';

import { useTranslations } from 'next-intl';
import { css } from 'styled-components';

import MarketingPageSection from 'src/app/components/Elements/MarketingPageSection';

import { CLEARRX_PHONE } from './constants';
import { ContentContainer } from './styles';

export const HubInvalidCode = () => {
  const t = useTranslations('hubInvalidCode');

  return (
    <MarketingPageSection>
      <ContentContainer>
        <Typography
          variant="body"
          css={css`
            margin-bottom: ${({ theme }) => theme.space.s7};
          `}
        >
          {t.rich('message', {
            phone: () => <a href={`tel:${CLEARRX_PHONE}`}>{CLEARRX_PHONE}</a>,
          })}
        </Typography>
      </ContentContainer>
    </MarketingPageSection>
  );
};
